module.exports = __webpack_public_path__ + "static/img/yzh.c60b0b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/itemImgs/yzh.jpg
// module id = qRuP
// module chunks = 0